// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import {BiArrowBack, BiTrash} from "react-icons/bi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../../components/loading/Loading";
import {
    addJobRequestTransaksiSelector,
    getJobRequestDetailUnit,
    updatePermintaanUnit,
} from "../../hrd/transaksi/job-request/AddjobRequestTransaksiSlice";
import {getMinKendaraan, kendaraanSelector,} from "../../master/kendaraan/kendaraanSlice";
import {Colors} from "../../../assets/Colors";
import Select from "react-select";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (typeof value === "number") {
            if (value !== -1) {
                status = true;
            }
        }

    }
    return status;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {
}) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [changed, setChanged] = useState(false);
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});
    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const changeHandlerActivity = (data) => {
        const newValues = {...values, Activity: data};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
    };

    const editHandler = (initValues) => {
        const newValues = {
            ...values,
            WSBNo: initValues.WSBNo,
            Unit: initValues.Unit,
            PermitToWork: initValues.PermitToWork,
            ShippingManifest: initValues.ShippingManifest,
            QuatationNo: initValues.QuatationNo,
            SPKNo: initValues.SPKNo,
            KlienID: initValues.KlienID,
            Priority: initValues.Priority,
            StatusKet: initValues.StatusKet,
            Activity: initValues.Activity,
            Status: initValues.Status,
            RequestUnitNo: initValues.RequestUnitNo,
            Klien: initValues.Klien,
        };
        setValues(newValues);
    };

    const editUnit = (value) => {
        const newValues = {
            ...values,
            Unit: value,
        };
        setValues(newValues);
    };

    const clearHandler = () => {
        setValues(initialState);
    };

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {
        values,
        changeHandler,
        editHandler,
        clearHandler,
        isValid,
        errors,
        touched,
        submitHandler,
        editUnit,
        changeHandlerActivity,
    };
}

function validate(validations, values) {
    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const PermintaanUnitDetail = ({}) => {
    const jobRequest = useSelector(addJobRequestTransaksiSelector);
    const kendaraan = useSelector(kendaraanSelector);
    let initialState = {
        PermitToWork: "",
        Status: "",
        QuatationNo: "",
        SPKNo: "",
        Priority: "",
        KlienID: "",
        StatusKet: "",
        Activity: [],
    };

    const param = useLocation();

    const validations = [
        ({QuatationNo}) =>
            isRequired(QuatationNo) || {QuatationNo: "Nomor Quatation wajib diisi"},
        ({SPKNo}) => isRequired(SPKNo) || {SPKNo: "Nomor SPK wajib diisi"},
        ({Priority}) =>
            isRequired(Priority) || {Priority: "Priority wajib diisi"},
        ({KlienID}) => isRequired(KlienID) || {KlienID: "ID Klien wajib diisi"},
    ];

    const {
        values,
        errors,
        touched,
        changeHandler,
        editHandler,
        editUnit,
        changeHandlerActivity,
    } = useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [Tanggal, setTanggal] = useState("");
    const [TanggalIncoming, setTanggalIncoming] = useState("");
    const [isValidTanggal, setIsValidTanggal] = useState(true);
    const [isValidTanggalIncoming, setIsValidTanggalIncoming] = useState(true);
    const [firstLoading, setFirstLoading] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [jobRequestList, setjobRequestList] = useState([]);
    const [currentData, setCurrentData] = useState({});
    const [dateChanged, setDateChanged] = useState({});
    const [unitPicker, setUnitPicker] = useState([]);

    function handleInsertJR() {
        let sendArray = {
            RequestUnitNo: values.RequestUnitNo,
            JRID: jobRequest.dataDetail.JRID,
            Unit: values.Unit
        };


        dispatch(updatePermintaanUnit(sendArray));
    }

    useEffect(() => {
        dispatch(getJobRequestDetailUnit({JRID: param.state.JRID}));
        dispatch(getMinKendaraan({search: ""}));
    }, []);

    useEffect(() => {
    });

    useEffect(() => {
        if (jobRequest.isGetDetailSuccess && !firstLoading) {
            if (values.Activity.length === 0) {
                changeHandlerActivity(jobRequest.dataDetail.Activity);
            }
            let activityPicker = []
            const initValues = {
                PermitToWork: jobRequest.dataDetail.PermitToWork,
                Status: jobRequest.dataDetail.Status,
                ShippingManifest: jobRequest.dataDetail.ShippingManifest,
                IncomingDate: jobRequest.dataDetail.IncomingDate,
                QuatationNo: jobRequest.dataDetail.QuatationNo,
                WSBNo: jobRequest.dataDetail.WSBNo,
                SPKNo: jobRequest.dataDetail.SPKNo,
                Priority: jobRequest.dataDetail.Priority,
                KlienID: jobRequest.dataDetail.KlienID,
                StatusKet: jobRequest.dataDetail.StatusKet,
                Activity: jobRequest.dataDetail.Activity,
                Unit: jobRequest.dataDetail.Unit,
                RequestUnitNo: jobRequest.dataDetail.RequestUnitNo,
                Klien: jobRequest.dataDetail.Klien,

            };
            editHandler(initValues);
            initValues.Activity && initValues.Activity.map(
                ({Name, Checked, DetailActivity}, index) => {
                    if (Checked === true) {
                        if (Name === "PORT_SERVICES") {
                            activityPicker.push("1")
                        }
                        if (Name === "WASTE_MANAGEMENT_SERVICES") {
                            activityPicker.push("2")
                        }
                    }
                })

            setUnitPicker(activityPicker)
            setTanggal(
                new Date(
                    new Date(jobRequest?.dataDetail && jobRequest?.dataDetail.Date)
                )
            );
            setTanggalIncoming(
                new Date(
                    new Date(
                        jobRequest?.dataDetail && jobRequest?.dataDetail.IncomingDate
                    )
                )
            );
            setFirstLoading(true);
        }
        if (jobRequest.isUpdateSuccess) {
            dispatch(getJobRequestDetailUnit({JRID: param.state.JRID}));
            setFirstLoading(true);
            navigate("/equipment/permintaan-unit");
        }
    });

    function handleInsertUnit() {
        let tempdata = JSON.parse(JSON.stringify(values));
        const Unit = {
            UnitID: "",
            Remarks: "",
        };
        if (!tempdata.Unit) {
            tempdata.Unit = [];
        }
        tempdata.Unit.push(Unit);
        editUnit(tempdata.Unit);
    }

    function deleteUnit(i) {
        let tempdata = JSON.parse(JSON.stringify(values));
        tempdata.Unit.splice(i, 1);
        editUnit(tempdata.Unit);
    }

    if (!firstLoading) {
        return <Loading/>;
    } else {

        return (
            <>
                <div className="md:ml-64">
                    <div
                        style={{background: Colors.white}}
                        className="pt-14 pb-16 px-3 md:px-8 h-auto"
                    >
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                        </div>
                    </div>
                    <div className="px-3 md:px-8 h-auto -mt-32">
                        <div className="flex w-full justify-end p-4 flex-col sm:flex-row pt-4">
                            <button
                                onClick={() => navigate("/equipment/permintaan-unit")}
                                className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                            >
                                <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                                Kembali
                            </button>
                            {parseInt(values.Status) > 104 ? (
                                <></>
                            ) : (
                                <button
                                    onClick={() => handleInsertJR()}
                                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                >
                                    Simpan
                                </button>
                            )}
                        </div>
                        <div className="flex flex-row">
                            <div className="px-4 py-4 flex-1">
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            No JR
                                        </label>
                                        <div className="inline-block relative w-full">
                                            <input
                                                disabled
                                                value={param.state.JRID}
                                                onChange={changeHandler}
                                                name="JRID"
                                                className={
                                                    (touched.QuatationNo || buttonTouched) &&
                                                    errors.QuatationNo
                                                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                }
                                                type="text"
                                            />
                                        </div>
                                        {(touched.QuatationNo || buttonTouched) &&
                                            errors.QuatationNo && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.QuatationNo}
                                                </p>
                                            )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Nomor Quatation
                                        </label>
                                        <div className="inline-block relative w-full">
                                            <input
                                                disabled
                                                value={values.QuatationNo}
                                                onChange={changeHandler}
                                                name="QuatationNo"
                                                className={
                                                    (touched.QuatationNo || buttonTouched) &&
                                                    errors.QuatationNo
                                                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                }
                                                type="text"
                                            />
                                        </div>
                                        {(touched.QuatationNo || buttonTouched) &&
                                            errors.QuatationNo && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.QuatationNo}
                                                </p>
                                            )}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Priority
                                        </label>
                                        <div className="inline-block relative w-full  ">
                                            <input
                                                disabled
                                                value={values.Priority}
                                                name="Priority"
                                                className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-light-gray-700 text-xs font-bold mb-2">
                                            Nomor WSB
                                        </label>
                                        <input
                                            value={values.WSBNo}
                                            onChange={changeHandler}
                                            name="WSBNo"
                                            className={
                                                (touched.SPKNo || buttonTouched) && errors.WSBNo
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.WSBNo || buttonTouched) && errors.WSBNo && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.WSBNo}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-light-gray-700 text-xs font-bold mb-2">
                                            Nomor SPK
                                        </label>
                                        <input
                                            value={values.SPKNo}
                                            onChange={changeHandler}
                                            name="SPKNo"
                                            className={
                                                (touched.SPKNo || buttonTouched) && errors.SPKNo
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.SPKNo || buttonTouched) && errors.SPKNo && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.SPKNo}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 flex-1">
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Client
                                        </label>
                                        <input
                                            disabled
                                            value={values.Klien}
                                            onChange={changeHandler}
                                            name="KlienID"
                                            className={
                                                (touched.KlienID || buttonTouched) && errors.KlienID
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.KlienID || buttonTouched) && errors.KlienID && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.KlienID}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3">
                                    <div className="w-full px-3 mb-6">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Tanggal
                                        </label>
                                        <DatePicker
                                            className={
                                                !isValidTanggal
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            disabled={values.Priority !== "P3"}
                                            selected={Tanggal}
                                            onChange={(date) => {
                                                setTanggal(date);
                                                setIsValidTanggal(true);
                                                if (showModalEdit) {
                                                    setDateChanged(true);
                                                }
                                            }}
                                        />
                                        {!isValidTanggal && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal pengajuan wajib diisi
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Shipping Manifest
                                        </label>
                                        <input
                                            disabled
                                            value={values.ShippingManifest}
                                            onChange={changeHandler}
                                            name="ShippingManifest"
                                            className={
                                                (touched.ShippingManifest || buttonTouched) &&
                                                errors.ShippingManifest
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.ShippingManifest || buttonTouched) &&
                                            errors.ShippingManifest && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.ShippingManifest}
                                                </p>
                                            )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Incoming Date / Time
                                        </label>
                                        <DatePicker
                                            disabled
                                            className={
                                                !isValidTanggalIncoming
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            selected={TanggalIncoming}
                                            onChange={(date) => {
                                                setTanggalIncoming(date);
                                                setIsValidTanggalIncoming(true);
                                            }}
                                        />
                                        {!isValidTanggalIncoming && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal Incoming wajib diisi
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase text-gray-700 tracking-wide text-700 text-xs font-bold mb-2">
                                            Permit to Work No
                                        </label>
                                        <input
                                            disabled
                                            value={values.PermitToWork}
                                            onChange={changeHandler}
                                            name="PermitToWork"
                                            className={
                                                (touched.PermitToWork || buttonTouched) &&
                                                errors.PermitToWork
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.PermitToWork || buttonTouched) &&
                                            errors.PermitToWork && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.PermitToWork}
                                                </p>
                                            )}
                                    </div>
                                </div>
                                {/*<div className="flex flex-wrap -mx-3 mb-6">*/}
                                {/*    <div className="w-full px-3 mb-6 md:mb-0">*/}
                                {/*        <label*/}
                                {/*            className="block uppercase text-green-700 tracking-wide text-700 text-xs font-bold mb-2">*/}
                                {/*            Request Unit No **/}
                                {/*        </label>*/}
                                {/*        <input*/}
                                {/*            value={values.RequestUnitNo}*/}
                                {/*            onChange={changeHandler}*/}
                                {/*            name="RequestUnitNo"*/}
                                {/*            className={*/}
                                {/*                (touched.RequestUnitNo || buttonTouched) &&*/}
                                {/*                errors.RequestUnitNo*/}
                                {/*                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"*/}
                                {/*                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"*/}
                                {/*            }*/}
                                {/*            type="text"*/}
                                {/*        />*/}
                                {/*        {(touched.RequestUnitNo || buttonTouched) &&*/}
                                {/*            errors.RequestUnitNo && (*/}
                                {/*                <p className="text-red-500 text-xs italic">*/}
                                {/*                    {errors.RequestUnitNo}*/}
                                {/*                </p>*/}
                                {/*            )}*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>

                        <div className="p-4">
                            <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                                <div
                                    style={{
                                        background: Colors.primary,
                                    }}
                                    className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                                >
                                    Unit
                                </div>
                                <button
                                    onClick={() => handleInsertUnit()}
                                    className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                >
                                    Tambah Unit
                                </button>
                                <Card className="flex flex-col items-center content-center rounded-t-none">
                                    <CardBody className="w-full pt-0 ">
                                        <div className="overflow-x-auto">
                                            <table className="table-auto w-full bg-transparent border-collapse">
                                                <thead>
                                                <tr>
                                                    <th></th>
                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                                    >
                                                        Unit
                                                    </th>

                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                                    >
                                                        Remarks
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {values.Unit &&
                                                    values.Unit.map((keyName, i) => (
                                                        <tr key={keyName + i}>
                                                            <th>
                                                                <button
                                                                    onClick={() => deleteUnit(i)}
                                                                    className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                                >
                                                                    <BiTrash className="text-xl text-red-800"/>
                                                                </button>
                                                            </th>
                                                            <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                <Select
                                                                    menuPortalTarget={
                                                                        document.body
                                                                    }
                                                                    value={kendaraan.minData.filter(
                                                                        ({value}) =>
                                                                            value ===
                                                                            keyName["UnitID"]
                                                                    )}
                                                                    onChange={(e) => {
                                                                        let tempdata = JSON.parse(
                                                                            JSON.stringify(values.Unit)
                                                                        );
                                                                        tempdata[i].UnitID = e.value;
                                                                        editUnit(tempdata);
                                                                    }}
                                                                    options={kendaraan.minData.filter(el => unitPicker.includes(el.CategoryID))}
                                                                />

                                                            </th>
                                                            <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                <input
                                                                    onChange={(text) => {
                                                                        let tempdata = JSON.parse(
                                                                            JSON.stringify(values.Unit)
                                                                        );
                                                                        tempdata[i].Remarks = text.target.value;
                                                                        editUnit(tempdata);
                                                                    }}
                                                                    value={keyName["Remarks"]}
                                                                    name="Type"
                                                                    className={
                                                                        "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-2  leading-tight outline-none bg-white border-gray-500"
                                                                    }
                                                                    type="text"
                                                                />
                                                            </th>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default PermintaanUnitDetail;
